import { useParams, useLocation, useSearchParams } from 'react-router-dom';
import { Link } from 'components/ui/link';
import type { ProjectNavigationItem } from './types';

import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from 'components/ui/sidebar';

export function NavProjects({
    projects,
}: {
    projects: ProjectNavigationItem[];
}) {
    const { projectGroupId } = useParams();
    const [searchParams, _] = useSearchParams();
    const location = useLocation();
    const maybeProjectIdQueryParam = searchParams.get('projectVersion');

    // If there's a specific version of the project selected, we want to maintain this across project pages
    const projectVersionQueryParam = maybeProjectIdQueryParam
        ? `?projectVersion=${maybeProjectIdQueryParam}`
        : '';

    if (!projectGroupId) return null;

    const isActive = (url: string) =>
        location.pathname === url.replace(':projectId', projectGroupId);

    return (
        <SidebarGroup className="group-data-[collapsible=icon]:hidden">
            <SidebarGroupLabel>Project</SidebarGroupLabel>
            <SidebarMenu>
                {projects.map((item) => (
                    <SidebarMenuItem key={item.name}>
                        <SidebarMenuButton
                            asChild
                            isActive={isActive(item.url)}
                        >
                            <Link
                                to={`${item.url.replace(
                                    ':projectId',
                                    projectGroupId,
                                )}${projectVersionQueryParam}`}
                            >
                                <item.icon />
                                <span>{item.name}</span>
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
        </SidebarGroup>
    );
}
